import { type ProductConfigurationMap } from '../../types';
import { isFedRamp } from '@atlassian/atl-context';
import { formatLabel } from '../providers/product-configuration-provider';
import messages from './messages';

export function buildTeamsProduct(
	productConfigurationMap: ProductConfigurationMap,
	isTeamsAsAppEnabled?: boolean,
): ProductConfigurationMap {
	if (isFedRamp() || !isTeamsAsAppEnabled) {
		return productConfigurationMap;
	}

	return {
		...productConfigurationMap,
		TEAMS: {
			label: formatLabel(messages.teams),
			iconKey: 'teams',
			key: 'teams',
			ordinal: 19,
		},
	};
}
